import { render, staticRenderFns } from "./EstudiosTabContent.vue?vue&type=template&id=6357e9ae"
import script from "./EstudiosTabContent.vue?vue&type=script&lang=js"
export * from "./EstudiosTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports